import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Dialog,
  DialogTitle,
  Divider,
  DialogContent,
  TextField,
  Button,
  DialogActions,
} from "@material-ui/core";
import * as React from "react";
import { colors } from "../constants/constants";
import ChipComponent from "../components/ChipComponent";

const drawerWidth = 340;
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3,
    },
    chip: {
      margin: theme.spacing(0.5),
    },
    gridList: {
      width: "auto",
      height: 150,
    },
    button: {
      margin: theme.spacing(1),
      width: "30%",
      height: 48,
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary,
    },
    control: {
      padding: theme.spacing(1) * 2,
    },
    appBar: {
      [theme.breakpoints.up("sm")]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
    },
    menuHideButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "none",
      },
    },
    menuShowButton: {
      marginRight: theme.spacing(2),
      [theme.breakpoints.up("sm")]: {
        display: "visible",
      },
      color: "black",
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    sectionDesktop: {
      display: "none",
      [theme.breakpoints.up("md")]: {
        display: "flex",
      },
    },
    avatar: {
      backgroundColor: colors.primaryColor,
      color: "#ffff",
    },
    toolbar: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: 0,
      paddingBottom: 8,
      minHeight: 64,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(3),
    },
    large: {
      margin: 10,
      width: theme.spacing(15),
      height: theme.spacing(15),
    },
  });
interface Props extends WithStyles<typeof styles> {
  open: any;
  onCategoryAdded: any;
  inspectionType: any;
  dialogTitle: any;
  onClose: any;
}
class AddInspectionCategoryDialog extends React.Component<Props> {
  state = {
    inspectionType: { value: "", label: "", categories: new Array<any>() },
    inspectionCategoryValue: { value: "", label: "" },
  };

  componentDidMount = () => {
    const { inspectionType } = this.props;
    this.setState({
      inspectionType: inspectionType,
    });
  };

  componentDidUpdate = (prevProps: any) => {
    if (
      prevProps.inspectionType.categories !==
      this.props.inspectionType.categories
    ) {
      this.setState({
        inspectionType: this.props.inspectionType,
      });
    }
  };

  handleClose = () => {
    this.props.onClose();
  };

  onInspectionCategoriesAddClicked = () => {
    if (this.state.inspectionCategoryValue) {
      let currentInspectionCategories = this.state.inspectionType.categories;
      currentInspectionCategories.push(this.state.inspectionCategoryValue);
      this.setState({
        inspectionCategories: currentInspectionCategories,
        inspectionCategoryValue: { value: "", label: "" },
      });
    }
  };

  handleRemoveInspectionCategoriesChip = (item: any, index: any) => {
    let mItem = { ...this.state.inspectionType };
    mItem.categories.splice(index, 1);
    this.setState({
      inspectionType: mItem,
    });
  };

  handleOnSave = () => {
    const { onCategoryAdded } = this.props;
    onCategoryAdded(this.state.inspectionType);
  };

  render() {
    const { open, dialogTitle, onClose } = this.props;
    return (
      <Dialog
        fullWidth
        onClose={() => this.handleClose()}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <DialogTitle id="simple-dialog-title">{dialogTitle}</DialogTitle>
        <Divider />
        <DialogContent>
          <TextField
            fullWidth
            style={{ margin: 10 }}
            id="standard-basic"
            label="Inspection Type"
            value={this.state.inspectionType.label}
            placeholder="Inspection type"
            onChange={(event: any) => {
              let currentinspectionType = this.state.inspectionType;
              currentinspectionType.value = event.target.value.toUpperCase();
              currentinspectionType.label = event.target.value;
              this.setState({
                inspectionType: currentinspectionType,
              });
            }}
          />
          <div
            style={{
              display: "flex",
              margin: 10,
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <TextField
              fullWidth
              id="standard-basic"
              label="Inspection Categories"
              value={this.state.inspectionCategoryValue.label}
              placeholder="Add Inspection category"
              onChange={(event: any) => {
                let currentinspectionCategoryValue = this.state
                  .inspectionCategoryValue;
                currentinspectionCategoryValue.value = event.target.value.includes(
                  "-"
                )
                  ? event.target.value.toUpperCase()
                  : event.target.value.replace(" ", "-").toUpperCase();
                currentinspectionCategoryValue.label = event.target.value;
                this.setState({
                  inspectionCategoryValue: currentinspectionCategoryValue,
                });
              }}
            />
            <Button
              variant="outlined"
              disabled={
                this.state.inspectionCategoryValue &&
                this.state.inspectionCategoryValue.label &&
                this.state.inspectionCategoryValue.value
                  ? false
                  : true
              }
              onClick={() => this.onInspectionCategoriesAddClicked()}
              style={{ marginLeft: 20 }}
            >
              ADD
            </Button>
          </div>
          {this.state.inspectionType.categories.map(
            (item: any, index: number) => {
              return (
                <ChipComponent
                  key={`chip-pos:${index.toString()}`}
                  title={item.label}
                  item={item}
                  index={index}
                  chipValue={this.state.inspectionCategoryValue}
                  onChipDelete={(mItem: any, nIndex: any) => {
                    this.handleRemoveInspectionCategoriesChip(mItem, nIndex);
                  }}
                  onChipEdit={(mItem: any, nIndex: any) => {
                    let mInspectionType = this.state.inspectionType;
                    mInspectionType.categories.splice(nIndex, 1, mItem);
                    this.setState({
                      inspectionType: mInspectionType,
                    });
                  }}
                />
              );
            }
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onClose()}>{"Cancel"}</Button>
          <Button
            disabled={
              this.state.inspectionType.categories.length > 0 ? false : true
            }
            onClick={() => {
              this.handleOnSave();
            }}
          >
            {"Save"}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default withStyles(styles)(AddInspectionCategoryDialog);
